module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('div', {
    staticClass: "box member-service-box"
  }, [_c('van-divider', [_vm._v("能力测试 · 人员信息")]), _vm._v(" "), _vm._l((_vm.list), function(member, index) {
    return _c('van-cell-group', {
      key: index
    }, [_c('van-cell', {
      attrs: {
        "title": "姓名",
        "value": member.name
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "性别",
        "value": member.sex
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "身份证号",
        "value": member.num
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "联系电话",
        "value": member.phone
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "微信",
        "value": member.weixin
      }
    }), _vm._v(" "), (_vm.row.memberstatus == 6) ? _c('van-cell', {
      attrs: {
        "title": "申报项目",
        "value": member.project
      }
    }) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus == 6 && (member.project == '花球男' || member.project == '花球女')) ? _c('van-cell', {
      attrs: {
        "title": "抱腿平衡",
        "value": member.score_btph
      }
    }) : (_vm.row.memberstatus == 6) ? _c('van-cell', {
      attrs: {
        "title": "肋木举腿",
        "value": member.score_lmjt
      }
    }) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus == 6) ? _c('van-cell', {
      attrs: {
        "title": "60s(击掌)俯卧撑",
        "value": member.score_fwc
      }
    }) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus == 6) ? _c('van-cell', {
      attrs: {
        "title": "技术技巧",
        "value": member.score_jsjq
      }
    }) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus == 6) ? _c('van-cell', {
      attrs: {
        "title": "总分",
        "value": member.score_total
      }
    }) : _c('van-cell', {
      attrs: {
        "title": "选择项目",
        "value": member.project,
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.onProjectOpen(index)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.projectShow),
      callback: function($$v) {
        _vm.projectShow = $$v
      },
      expression: "projectShow"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.projectColumns,
      "show-toolbar": ""
    },
    on: {
      "cancel": function($event) {
        _vm.projectShow = false
      },
      "confirm": _vm.onProjectConfirm
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), (_vm.row.memberstatus != 6) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存并继续\n      ")])], 1) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-faf23826","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/skill/AbilityApplyStep2.vue
// module id = 2635
// module chunks = 0